// Columns of the tables about customers rather than the catalogue: eSIM reservations and packages,
// the blocks on an account, broadcast notifications, and what a customer reported. The bookkeeping
// columns of these tables (guids, external ids, "already notified" stamps) are hidden instead, in
// changeHistoryDictionary.ts — a name would not make them worth reading.
export const CUSTOMER_COLUMN_LABELS: Record<string, string> = {
  EsimReservationId: "Rezervimi eSIM",
  ActivateDateUtc: "Aktivizuar më",
  ExpirationDateUtc: "Skadon më",
  ClaimExpirationDateUtc: "Afati i tërheqjes",
  IsTopUp: "Rimbushje",
  ToBeClaimed: "Për t'u tërhequr",
  SourceChannel: "Kanali i blerjes",
  LocationZoneId: "Zona",
  JourneyAddonCost: "Kostoja si shtesë udhëtimi",
  MobileAppCost: "Kostoja në aplikacion",
  MobileAppOldCost: "Kostoja e vjetër në aplikacion",
  AllowedEmail: "Email-i i lejuar",
  CompanyName: "Kompania",
  HelpCenterUrl: "Qendra e ndihmës",
  BlockAll: "Bllokim i plotë",
  BlockReason: "Arsyeja e bllokimit",
  BlockJourneyReservationStripe: "Bllokon rezervimet me Stripe",
  BlockJourneyReservationNlb: "Bllokon rezervimet me NLB",
  BlockEsimReservationStripe: "Bllokon eSIM me Stripe",
  BlockEsimReservationNlb: "Bllokon eSIM me NLB",
  ScheduledAtUtc: "Planifikuar për",
  StartedAtUtc: "Filloi më",
  CompletedAtUtc: "Përfundoi më",
  SentCount: "Të dërguara",
  DeliveredCount: "Të pranuara",
  FailedCount: "Të dështuara",
  TotalDevices: "Pajisje gjithsej",
  TargetPlatform: "Platforma",
  TargetLanguages: "Gjuhët",
  TargetRoute: "Ekrani që hapet",
  TargetUserEmails: "Përdoruesit e synuar",
  MinAppVersion: "Versioni minimal i aplikacionit",
  ErrorMessage: "Gabimi",
  Message: "Mesazhi",
  ResultsCount: "Numri i rezultateve",
  RouteOrigin: "Nisja e kërkuar",
  RouteDestination: "Destinacioni i kërkuar",
  SearchDate: "Data e kërkimit",
  TripDepartureTime: "Ora e nisjes së orarit",
  TripArrivalTime: "Ora e mbërritjes së orarit"
};
